/* Maiknara — interacciones del tema (vanilla). Port fiel del Next. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HEART = 'M12 21c-.5 0-6.2-3.8-8.8-7.6C1.4 10.7 2 7.3 4.5 5.7a5 5 0 0 1 6.4.9l1.1 1.2 1.1-1.2a5 5 0 0 1 6.4-.9c2.5 1.6 3.1 5 1.3 7.7C18.2 17.2 12.5 21 12 21Z';

  /* ─────────── Reveal observer ─────────── */
  function reveals() {
    var els = document.querySelectorAll('[data-reveal], .mk-words');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Failsafe: lo que ya está en pantalla se revela de inmediato, sin depender de que
    // el observer despache (p. ej. pestaña en segundo plano). El scroll-reveal sigue vía IO.
    function revealVisible() {
      els.forEach(function (e) {
        if (e.classList.contains('is-in')) return;
        var r = e.getBoundingClientRect();
        if (r.top < innerHeight * 0.94 && r.bottom > 0) { e.classList.add('is-in'); io.unobserve(e); }
      });
    }
    revealVisible();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) revealVisible(); });
  }

  /* ─────────── Intro "el regalo" ─────────── */
  function intro() {
    var root = document.getElementById('mk-intro');
    if (!root) return;
    var seen = false; try { seen = sessionStorage.getItem('mk-intro') === '1'; } catch (e) {}
    if (seen) { root.remove(); return; }
    document.body.style.overflow = 'hidden';
    var done = false, timers = [];
    var at = function (ms, fn) { timers.push(setTimeout(fn, ms)); };
    var canvas = root.querySelector('.mki-confetti');
    var gift = root.querySelector('[data-gift]');
    var lid = root.querySelector('[data-lid]');
    var fly = root.querySelector('[data-fly]');
    var dot = root.querySelector('[data-dot]');
    var heartDot = root.querySelector('[data-heartdot]');

    function finish(fast) {
      if (done) return; done = true;
      try { sessionStorage.setItem('mk-intro', '1'); } catch (e) {}
      timers.forEach(clearTimeout);
      root.style.animationDuration = fast ? '0.45s' : '0.9s';
      root.classList.add('leaving');
      setTimeout(function () { document.body.style.overflow = ''; root.remove(); }, fast ? 460 : 920);
      window.removeEventListener('pointerdown', skip); window.removeEventListener('keydown', skip);
    }
    var skip = function () { finish(true); };
    window.addEventListener('pointerdown', skip); window.addEventListener('keydown', skip);
    var btn = root.querySelector('[data-skip]'); if (btn) btn.addEventListener('click', skip);

    if (reduce) {
      root.querySelectorAll('.mki-late').forEach(function (e) { e.style.opacity = '1'; });
      root.querySelectorAll('.l').forEach(function (e) { e.style.transform = 'none'; e.style.opacity = '1'; });
      if (heartDot) heartDot.style.opacity = '1';
      at(1500, function () { finish(false); });
      return;
    }

    // Fase 1: dibujar caja
    root.querySelectorAll('.draw').forEach(function (el, i) {
      var len = 200; try { len = el.getTotalLength() || 200; } catch (e) {}
      el.style.strokeDasharray = len; el.style.strokeDashoffset = len;
      el.animate([{ strokeDashoffset: len }, { strokeDashoffset: 0 }],
        { duration: 560, delay: 90 + i * 150, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
    });
    root.querySelectorAll('.mki-spark').forEach(function (el, i) {
      el.animate([{ opacity: 0, transform: 'scale(0) rotate(0deg)' },
        { opacity: 1, transform: 'scale(1.15) rotate(40deg)', offset: 0.6 },
        { opacity: 0.85, transform: 'scale(1) rotate(60deg)' }],
        { duration: 640, delay: 700 + i * 110, easing: 'cubic-bezier(.34,1.56,.64,1)', fill: 'forwards' });
    });
    // Fase 2: tiembla
    at(1350, function () {
      if (gift) gift.animate([{ transform: 'rotate(0deg) scale(1)' },
        { transform: 'rotate(-3.5deg) scale(1.02)', offset: .25 },
        { transform: 'rotate(3.5deg) scale(1.03)', offset: .5 },
        { transform: 'rotate(-2deg) scale(1.04)', offset: .75 },
        { transform: 'rotate(0deg) scale(1.05)' }], { duration: 420, easing: 'ease-in-out', fill: 'forwards' });
    });
    // Fase 3: tapa vuela + confeti + corazón
    at(1800, function () {
      if (lid) lid.animate([{ transform: 'rotate(0) translate(0,0)', opacity: 1 },
        { transform: 'rotate(-38deg) translate(-26px,-70px)', opacity: 1, offset: .55 },
        { transform: 'rotate(-72deg) translate(-52px,-150px)', opacity: 0 }],
        { duration: 680, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
      confetti(canvas);
      if (gift && fly && dot) {
        var g = gift.getBoundingClientRect(), d = dot.getBoundingClientRect();
        var sx = g.left + g.width / 2, sy = g.top + g.height * 0.42;
        var ex = d.left + d.width / 2, ey = d.top + d.height / 2;
        var cxp = (sx + ex) / 2 + (ex > sx ? -40 : 40), cyp = Math.min(sy, ey) - 190;
        var frames = [];
        for (var k = 0; k <= 26; k++) {
          var t = k / 26, mt = 1 - t;
          var x = mt * mt * sx + 2 * mt * t * cxp + t * t * ex;
          var y = mt * mt * sy + 2 * mt * t * cyp + t * t * ey;
          var s = Math.min(1.35, 0.4 + Math.sin(Math.PI * Math.min(1, t * 1.05)) * 0.75 + t * 0.15);
          frames.push({ transform: 'translate(' + x + 'px,' + y + 'px) scale(' + s + ') rotate(' + ((t - .5) * 40) + 'deg)', opacity: t < 0.04 ? 0 : 1 });
        }
        fly.style.opacity = '1';
        var a = fly.animate(frames, { duration: 850, delay: 120, easing: 'cubic-bezier(.3,0,.35,1)', fill: 'forwards' });
        a.onfinish = function () {
          fly.style.opacity = '0';
          if (heartDot) { heartDot.style.opacity = '1'; heartDot.animate([
            { transform: 'translateX(-50%) scale(1.9)' }, { transform: 'translateX(-50%) scale(.82)', offset: .45 },
            { transform: 'translateX(-50%) scale(1.15)', offset: .72 }, { transform: 'translateX(-50%) scale(1)' }],
            { duration: 480, easing: 'cubic-bezier(.34,1.56,.64,1)', fill: 'forwards' }); }
          var ring = document.createElement('div');
          ring.style.cssText = 'position:fixed;left:' + ex + 'px;top:' + ey + 'px;width:8px;height:8px;margin:-4px;border-radius:999px;border:2px solid #f2246b;z-index:6;pointer-events:none';
          document.body.appendChild(ring);
          ring.animate([{ transform: 'scale(1)', opacity: .9 }, { transform: 'scale(5)', opacity: 0 }], { duration: 550, fill: 'forwards' }).onfinish = function () { ring.remove(); };
        };
      }
    });
    // Fase 4: letras
    at(1980, function () { root.querySelectorAll('.l').forEach(function (el, i) { el.style.animationDelay = (i * 48) + 'ms'; el.classList.add('in'); }); });
    // Fase 5: líneas finales
    at(2750, function () {
      root.querySelectorAll('.mki-late').forEach(function (el, i) {
        var kf = [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }];
        if (i === 0) { kf[0].letterSpacing = '0.6em'; kf[1].letterSpacing = '0.34em'; }
        el.animate(kf, { duration: 700, delay: i * 160, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
      });
    });
    at(4400, function () { finish(false); });
  }

  function heartPath(ctx, s) {
    var k = s / 16; ctx.beginPath();
    ctx.moveTo(0, 4 * k);
    ctx.bezierCurveTo(-2 * k, -2 * k, -8 * k, 0, -8 * k, 5 * k);
    ctx.bezierCurveTo(-8 * k, 9 * k, -3 * k, 12 * k, 0, 15 * k);
    ctx.bezierCurveTo(3 * k, 12 * k, 8 * k, 9 * k, 8 * k, 5 * k);
    ctx.bezierCurveTo(8 * k, 0, 2 * k, -2 * k, 0, 4 * k);
    ctx.closePath(); ctx.fill();
  }
  function confetti(canvas) {
    if (!canvas) return;
    var dpr = Math.min(2, devicePixelRatio || 1);
    var W = innerWidth * dpr, H = innerHeight * dpr;
    canvas.width = W; canvas.height = H; canvas.style.width = innerWidth + 'px'; canvas.style.height = innerHeight + 'px';
    var ctx = canvas.getContext('2d');
    var cx = W / 2, cy = H * 0.44;
    var cols = ['#f2246b', '#f16593', '#c38f2d', '#f4a8ba', '#e8b45a'];
    var P = [];
    for (var i = 0; i < 110; i++) {
      var ang = -Math.PI / 2 + (Math.random() - .5) * 1.9, sp = (260 + Math.random() * 620) * dpr;
      var kind = Math.random() < .34 ? 0 : (Math.random() < .5 ? 1 : 2);
      P.push({ x: cx + (Math.random() - .5) * 60 * dpr, y: cy, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp,
        rot: Math.random() * 6.28, vr: (Math.random() - .5) * 9, size: (5 + Math.random() * 7) * dpr,
        kind: kind, col: cols[i % cols.length], life: 0, ttl: 1.15 + Math.random() * .75 });
    }
    var last = performance.now(), stop = false;
    setTimeout(function () { stop = true; }, 2400);
    function frame(t) {
      var dt = Math.min(0.033, (t - last) / 1000); last = t;
      ctx.clearRect(0, 0, W, H); var alive = 0;
      P.forEach(function (p) {
        p.life += dt; if (p.life > p.ttl) return; alive++;
        p.vy += 1500 * dpr * dt; p.vx *= 1 - dt * 1.1; p.vy *= 1 - dt * 0.25;
        p.x += p.vx * dt; p.y += p.vy * dt; p.rot += p.vr * dt;
        var a = 1 - Math.pow(p.life / p.ttl, 3);
        ctx.save(); ctx.globalAlpha = Math.max(0, a); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.col;
        if (p.kind === 0) heartPath(ctx, p.size);
        else if (p.kind === 1) ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        else { ctx.beginPath(); ctx.arc(0, 0, p.size / 2.4, 0, 6.28); ctx.fill(); }
        ctx.restore();
      });
      if (alive && !stop) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ─────────── Cursor "el detallito" (péndulo) ─────────── */
  function cursor() {
    var root = document.getElementById('mk-cursor');
    if (!root) return;
    if (!matchMedia('(pointer:fine)').matches || reduce) { root.remove(); return; }
    document.documentElement.classList.add('mk-cursor');
    var gift = root.querySelector('[data-gift]');
    var px = -100, py = -100, cx = -100, cy = -100, vx = 0, theta = 0, omega = 0, lastT = performance.now(), lastSpark = 0, shown = false;
    var sparkPool = [], SPARK = 'M12 2c.9 5.2 2.6 8.1 10 10-7.4 1.9-9.1 4.8-10 10-.9-5.2-2.6-8.1-10-10 7.4-1.9 9.1-4.8 10-10Z';
    function spark(x, y) {
      var el = sparkPool.find(function (e) { return e._free; });
      if (!el) { if (sparkPool.length < 14) { el = document.createElement('div'); el.className = 'mkc-spark'; el.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="' + SPARK + '"/></svg>'; document.body.appendChild(el); sparkPool.push(el); } else return; }
      el._free = false; var jx = (Math.random() - .5) * 18, jy = (Math.random() - .5) * 18;
      el.animate([{ opacity: 1, transform: 'translate(' + (x + jx) + 'px,' + (y + jy) + 'px) scale(.4) rotate(0deg)' },
        { opacity: 0, transform: 'translate(' + (x + jx) + 'px,' + (y + jy - 26) + 'px) scale(1.15) rotate(90deg)' }],
        { duration: 620, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' }).onfinish = function () { el.style.opacity = '0'; el._free = true; };
    }
    function burst(x, y) {
      for (var i = 0; i < 6; i++) {
        var el = document.createElement('div'); el.className = 'mkc-heartburst';
        var sz = 8 + Math.random() * 7; el.innerHTML = '<svg width="' + sz + '" height="' + sz + '" viewBox="0 0 24 24" fill="currentColor"><path d="' + HEART + '"/></svg>';
        document.body.appendChild(el);
        var ang = (i / 6) * 6.28 + Math.random() * .6, dist = 26 + Math.random() * 26;
        el.animate([{ opacity: 1, transform: 'translate(' + x + 'px,' + y + 'px) scale(.3)' },
          { opacity: 0, transform: 'translate(' + (x + Math.cos(ang) * dist) + 'px,' + (y + Math.sin(ang) * dist - 14) + 'px) scale(1) rotate(' + ((Math.random() - .5) * 90) + 'deg)' }],
          { duration: 700, fill: 'forwards' }).onfinish = function () { this.remove(); }.bind(el);
      }
    }
    addEventListener('pointermove', function (e) {
      px = e.clientX; py = e.clientY;
      if (root.style.opacity !== '1') { root.style.opacity = '1'; } shown = true;
      var hot = e.target.closest && e.target.closest("a, button, [role='button'], input, select, textarea, summary, label, [data-cursor]");
      root.classList.toggle('is-hover', !!hot);
    });
    addEventListener('pointerdown', function (e) { root.classList.add('is-down'); omega += (Math.random() - .5) * 6; burst(e.clientX, e.clientY); });
    addEventListener('pointerup', function () { root.classList.remove('is-down'); });
    document.documentElement.addEventListener('mouseleave', function () { root.style.opacity = '0'; });
    document.documentElement.addEventListener('mouseenter', function () { root.style.opacity = '1'; });
    window.addEventListener('focus', function () { root.style.opacity = '1'; });
    function tick(t) {
      var dt = Math.min(0.032, (t - lastT) / 1000 || 0.016); lastT = t;
      var pcx = cx; cx += (px - cx) * Math.min(1, dt * 26); cy += (py - cy) * Math.min(1, dt * 26);
      var iv = (cx - pcx) / dt; vx += (iv - vx) * Math.min(1, dt * 10);
      var L = 46, g = 34;
      omega += ((-vx * 0.9) / L) * Math.cos(theta) * dt * 6;
      omega += -(g / L) * Math.sin(theta) * dt * 14;
      omega *= 1 - Math.min(1, dt * 3.6); theta += omega * dt;
      theta = Math.max(-0.9, Math.min(0.9, theta));
      root.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      if (gift) gift.style.transform = 'rotate(' + (theta * 180 / Math.PI) + 'deg)';
      if (Math.abs(vx) > 900 && t - lastSpark > 90 && shown) { spark(cx, cy + 26); lastSpark = t; }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ─────────── Header (scroll + menú móvil) ─────────── */
  function header() {
    var h = document.getElementById('mk-header');
    if (h) { var on = function () { h.classList.toggle('is-scrolled', scrollY > 24); }; on(); addEventListener('scroll', on, { passive: true }); }
    var open = document.getElementById('mk-menu-open'), panel = document.getElementById('mk-menu'), close = document.getElementById('mk-menu-close'), back = document.getElementById('mk-menu-back');
    function set(o) { if (!panel) return; panel.classList.toggle('is-open', o); document.body.style.overflow = o ? 'hidden' : ''; }
    if (open) open.addEventListener('click', function () { set(true); });
    if (close) close.addEventListener('click', function () { set(false); });
    if (back) back.addEventListener('click', function () { set(false); });
  }

  /* ─────────── Galería producto ─────────── */
  function gallery() {
    var g = document.querySelector('[data-gallery]'); if (!g) return;
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src'); if (!src || !main) return;
        main.src = src; main.classList.remove('mk-fade-swap'); void main.offsetWidth; main.classList.add('mk-fade-swap');
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('border-fuchsia', 'scale-[1.03]'); b.classList.add('border-blush', 'opacity-75'); });
        btn.classList.add('border-fuchsia', 'scale-[1.03]'); btn.classList.remove('border-blush', 'opacity-75');
      });
    });
  }

  /* ─────────── BuyBox (variante + cantidad) ─────────── */
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 });
  }
  function buybox() {
    var box = document.querySelector('[data-buybox]'); if (!box) return;
    var variants = [];
    try { variants = JSON.parse(box.getAttribute('data-variants') || '[]'); } catch (e) {}
    var idInput = box.querySelector('[data-variant-id]');
    var priceEl = box.querySelector('[data-price]');
    var qtyEl = box.querySelector('[data-qty]');
    var qty = 1, current = variants[0] || null;
    var mainImg = document.querySelector('[data-gallery-main]');
    function render() {
      if (current && priceEl) {
        priceEl.textContent = money(current.price * qty);
        priceEl.classList.remove('mk-fade-swap'); void priceEl.offsetWidth; priceEl.classList.add('mk-fade-swap');
      }
      if (idInput && current) idInput.value = current.id;
      if (qtyEl) qtyEl.textContent = qty;
      if (mainImg && current && current.featured_image && current.featured_image.src) {
        if (mainImg.src !== current.featured_image.src) {
          mainImg.src = current.featured_image.src;
          mainImg.classList.remove('mk-fade-swap'); void mainImg.offsetWidth; mainImg.classList.add('mk-fade-swap');
        }
      }
    }
    box.querySelectorAll('[data-variant]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = parseInt(chip.getAttribute('data-variant'), 10);
        current = variants.find(function (v) { return v.id === id; }) || current;
        box.querySelectorAll('[data-variant]').forEach(function (c) { c.setAttribute('data-active', 'false'); c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('data-active', 'true'); chip.setAttribute('aria-pressed', 'true');
        render();
      });
    });
    var minus = box.querySelector('[data-qty-minus]'), plus = box.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); });
    if (plus) plus.addEventListener('click', function () { qty = Math.min(99, qty + 1); render(); });
    var add = box.querySelector('[data-add]');
    if (add) add.addEventListener('click', function () {
      if (!current) return;
      var props = {};
      box.querySelectorAll('[data-prop]').forEach(function (el) { var v = (el.value || '').trim(); if (v) props[el.getAttribute('data-prop')] = v; });
      cartAdd(current.id, qty, props);
    });
    render();
  }

  /* ─────────── Catálogo: filtros + búsqueda ─────────── */
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function catalog() {
    var wrap = document.querySelector('[data-catalog]'); if (!wrap) return;
    var grid = wrap.querySelector('[data-grid]'); var count = wrap.querySelector('[data-count]');
    var empty = wrap.querySelector('[data-empty]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
    var cat = null, q = '';
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var okCat = !cat || c.getAttribute('data-cat') === cat;
        var okQ = !q || norm(c.getAttribute('data-search')).indexOf(norm(q)) > -1;
        var vis = okCat && okQ; c.style.display = vis ? '' : 'none'; if (vis) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' detalle' : ' detalles');
      if (empty) empty.style.display = n ? 'none' : '';
      grid.classList.remove('mk-fade-swap'); void grid.offsetWidth; grid.classList.add('mk-fade-swap');
    }
    wrap.querySelectorAll('[data-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = chip.getAttribute('data-filter') || '';
        cat = (cat === v || v === '') ? (v === '' ? null : (cat === v ? null : v)) : v;
        if (v === '') cat = null;
        wrap.querySelectorAll('[data-filter]').forEach(function (c) { c.setAttribute('data-active', (c.getAttribute('data-filter') || '') === (cat || '') ? 'true' : 'false'); });
        apply();
      });
    });
    var search = wrap.querySelector('[data-search-input]');
    if (search) search.addEventListener('input', function () { q = search.value; apply(); });
    apply();
  }

  /* ─────────── Carrito AJAX + drawer ─────────── */
  function cartAdd(id, qty, props) {
    var item = { id: id, quantity: qty || 1 };
    if (props && Object.keys(props).length) item.properties = props;
    fetch((window.mkRoutes && window.mkRoutes.cartAdd) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json(); }).then(function () { refreshCart(true); });
  }
  window.mkCartAdd = cartAdd;
  function refreshCart(openDrawer) {
    fetch((window.mkRoutes && window.mkRoutes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (b) {
          b.textContent = cart.item_count; b.style.display = cart.item_count > 0 ? '' : 'none';
        });
        renderDrawer(cart);
        if (openDrawer) toggleDrawer(true);
      });
  }
  function renderDrawer(cart) {
    var body = document.querySelector('[data-cart-body]'); if (!body) return;
    if (!cart.items.length) { body.innerHTML = '<p class="text-center text-ink-soft py-16">Tu detalle está vacío.</p>'; }
    else {
      body.innerHTML = cart.items.map(function (it) {
        return '<div class="flex gap-3 py-3 border-b border-blush">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" class="w-16 h-16 rounded-xl object-cover bg-blush-soft">' +
          '<div class="flex-1"><p class="font-semibold text-sm text-ink">' + it.product_title + '</p>' +
          '<p class="text-xs text-ink-soft">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : '') + 'x' + it.quantity + '</p>' +
          (it.properties && Object.keys(it.properties).length ? '<p class="text-[0.7rem] text-fuchsia-deep mt-0.5">✨ ' + Object.keys(it.properties).map(function (k) { return it.properties[k]; }).join(' · ') + '</p>' : '') +
          '<p class="text-sm font-bold text-fuchsia-deep mt-1">' + money(it.final_line_price) + '</p></div></div>';
      }).join('');
    }
    var total = document.querySelector('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
  }
  function toggleDrawer(o) {
    var d = document.getElementById('mk-cart'); if (!d) return;
    d.classList.toggle('is-open', o); document.body.style.overflow = o ? 'hidden' : '';
  }
  function cart() {
    document.querySelectorAll('[data-cart-btn]').forEach(function (b) { b.addEventListener('click', function () { toggleDrawer(true); }); });
    var close = document.getElementById('mk-cart-close'), back = document.getElementById('mk-cart-back');
    if (close) close.addEventListener('click', function () { toggleDrawer(false); });
    if (back) back.addEventListener('click', function () { toggleDrawer(false); });
    refreshCart(false);
  }

  /* ─────────── init ─────────── */
  /* ─────────── Relacionados: mezclar y mostrar N (siempre rotan) ─────────── */
  function related() {
    var pool = document.querySelector('[data-related-pool]'); if (!pool) return;
    var n = parseInt(pool.getAttribute('data-show') || '4', 10);
    var cards = Array.prototype.slice.call(pool.querySelectorAll('[data-related-item]'));
    for (var i = cards.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = cards[i]; cards[i] = cards[j]; cards[j] = t; }
    cards.forEach(function (c, idx) { pool.appendChild(c); c.style.display = idx < n ? '' : 'none'; });
  }

  function init() { reveals(); intro(); cursor(); header(); gallery(); buybox(); catalog(); related(); cart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
